/**
 * One change applied to the ticked rows.
 */

import React, { useState } from 'react';

export default function BulkBar({ count, meta, busy, onApply }) {
  const [action, setAction] = useState('status');
  const [value, setValue] = useState('open');

  if (!count) return null;

  function changeAction(event) {
    const next = event.target.value;
    setAction(next);
    if (next === 'status') setValue('open');
    else if (next === 'priority') setValue('normal');
    else if (next === 'type') setValue('bug');
    else setValue('');
  }

  function apply(event) {
    event.preventDefault();
    if (action === 'assign') onApply('assign', value ? { email: value } : null);
    else if (action === 'type') onApply('type', { type: value });
    else if (action === 'tag') onApply('tag', value.trim());
    else onApply(action, value);
  }

  return (
    <form className="support-bulk" onSubmit={apply}>
      <span>{count} selected</span>
      <select className="rf-input" aria-label="Bulk action" value={action} onChange={changeAction}>
        <option value="status">Set status</option>
        <option value="assign">Assign</option>
        <option value="priority">Set priority</option>
        <option value="tag">Add tag</option>
        <option value="type">Set type</option>
      </select>
      {action === 'status' && (
        <select className="rf-input" aria-label="Status" value={value} onChange={(event) => setValue(event.target.value)}>
          {(meta?.statuses || []).filter((item) => item.id !== 'new').map((item) => (
            <option key={item.id} value={item.id}>{item.label}</option>
          ))}
        </select>
      )}
      {action === 'assign' && (
        <select className="rf-input" aria-label="Assignee" value={value} onChange={(event) => setValue(event.target.value)}>
          <option value="">Unassigned</option>
          {(meta?.staff || []).map((person) => (
            <option key={person.email} value={person.email}>{person.name}</option>
          ))}
        </select>
      )}
      {action === 'priority' && (
        <select className="rf-input" aria-label="Priority" value={value} onChange={(event) => setValue(event.target.value)}>
          {(meta?.priorities || []).map((item) => (
            <option key={item.id} value={item.id}>{item.label}</option>
          ))}
        </select>
      )}
      {action === 'tag' && (
        <input
          className="rf-input"
          aria-label="Tag"
          list="support-bulk-tags"
          value={value}
          onChange={(event) => setValue(event.target.value)}
          required
        />
      )}
      {action === 'type' && (
        <select className="rf-input" aria-label="Type" value={value} onChange={(event) => setValue(event.target.value)}>
          {(meta?.types || []).map((item) => (
            <option key={item.id} value={item.id}>{item.label}</option>
          ))}
        </select>
      )}
      <datalist id="support-bulk-tags">
        {(meta?.tags || []).map((item) => <option key={item.slug} value={item.slug} />)}
      </datalist>
      <button type="submit" className="rf-btn rf-btn-primary" disabled={busy}>Apply</button>
    </form>
  );
}
